import { render, staticRenderFns } from "./systemGoldSettingManage.vue?vue&type=template&id=4eb3d77c&scoped=true"
import script from "./systemGoldSettingManage.vue?vue&type=script&lang=js"
export * from "./systemGoldSettingManage.vue?vue&type=script&lang=js"
import style0 from "./systemGoldSettingManage.vue?vue&type=style&index=0&id=4eb3d77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb3d77c",
  null
  
)

export default component.exports